import { render, staticRenderFns } from "./BCXMessengerUserBanner.vue?vue&type=template&id=70710ae4&scoped=true"
import script from "./BCXMessengerUserBanner.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCXMessengerUserBanner.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BCXMessengerUserBanner.vue?vue&type=style&index=0&id=70710ae4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70710ae4",
  null
  
)

export default component.exports